import { BaseService } from './base.service';

export class NotificationsService extends BaseService {
  static get resourceEndpoint() {
    return 'notifications';
  }
}